// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"styles-module--linkButton---BCfP"};